<script>
    import { onMount, onDestroy } from "svelte";
    import { fly } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';

    import { idb } from "../db";

    import { appliances } from '../store/appliances';
    import { page, modal } from '../store/nav';

    import Accordion from "../components/equipAccordion.svelte";

    export let back_nav = false;

    onMount(async ()=>{
        await appliances.init();
        console.log($appliances);
    });
    onDestroy(() => {
        idb.save('pc_misc_reco', $appliances);
    });

    const changeStatus = e => appliances.editSingleField(e.detail.uid, `has`, e.detail.has);

</script>

<section id="list" in:fly="{{ x: back_nav ? -250 : 250, duration: 150 }}"  out:fly="{{ x: 250, duration: 150, delay:150 }}" class="z-0 fixed top-0 left-0 h-screen w-screen font-primaryBold text-primary flex flex-col space-y-8 pt-5 pl-7 bg-secondary" >
    <section id="top-bar" class="flex pr-7 justify-between items-stretch ">
        <div id="back-btn" class="" on:click|stopPropagation={page.referrer} >
            <svg viewBox="0 0 18 18" class="fill-primary mt-3.5 h-5" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7803 2.46967C12.0732 2.76256 12.0732 3.23744 11.7803 3.53033L6.31066 9L11.7803 14.4697C12.0732 14.7626 12.0732 15.2374 11.7803 15.5303C11.4874 15.8232 11.0126 15.8232 10.7197 15.5303L4.71967 9.53033C4.42678 9.23744 4.42678 8.76256 4.71967 8.46967L10.7197 2.46967C11.0126 2.17678 11.4874 2.17678 11.7803 2.46967Z"/>
            </svg>
        </div>
        <div id="title" class="place-self-center font-primaryXBold text-lg">My Kitchen</div>
        <div id="title-menu"class="w-10 h-12 place-self-center" >
            
        </div>
    </section>

    <section id="all" class="flex flex-col pr-7 space-y-5 overflow-scroll no-scrollbar grow">
        <section class="flex">
            <span class="italic">Select the equipment you have at home in order for us to only show recipes relevant to you. You can also check a few recommendations we have for each of them if you're in a shopping mood. </span>
        </section>
        <section id="all-list" class="flex pl-4 space-y-5 flex-col grow">
            <!--{#each Object.keys($stores) as store}-->
            {#if $appliances}
            {#each $appliances as appliance}
                <Accordion entry={appliance} on:changeStatus={changeStatus} />
                <!--section class="flex space-x-2 justify-between" >      
                    <div class:selected={appliance.has} class="place-self-center capitalize p-4" on:click|stopPropagation="{() => changeStatus(appliance.uid, !appliance.has)}">
                        {appliance.name}
                    </div>
                    <section class="place-self-center flex space-x-1">
                        {#each appliance.reco as reco}
                        <a target="_blank" href={reco.link}>
                        <section class="text-sm text-secondary h-6 italic flex space-x-1 bg-primary rounded-3xl px-1.5">
                            <span>{reco.type}</span>
                            <img src="/img/stores/4e3a.png" alt="" class="w-3 h-3 mt-1.5">
                        </section>
                        </a>
                        {/each}
                    </section>
                </section-->
            {/each}
            {/if}
            <span class="text-sm italic">As a member of the Amazon Affiliate Program we may earn a commission when you purchase through the links above at no extra cost to you.</span>
        </section>
    </section>

</section>       

<style lang="postcss">
</style>
